import { render, staticRenderFns } from "./EditorProfileName.vue?vue&type=template&id=06eb97f8&scoped=true&"
import script from "./EditorProfileName.vue?vue&type=script&lang=js&"
export * from "./EditorProfileName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb97f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06eb97f8')) {
      api.createRecord('06eb97f8', component.options)
    } else {
      api.reload('06eb97f8', component.options)
    }
    module.hot.accept("./EditorProfileName.vue?vue&type=template&id=06eb97f8&scoped=true&", function () {
      api.rerender('06eb97f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/EditorProfileName.vue"
export default component.exports